import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";

export const resetSitesState = createAction("[Sites] Reset Sites State Action");

export const getSitesList = createAction(
  "[Sites] Get All Sites List Action",
  props<{ options: any }>()
);
export const loadSitesList = createAction(
  "[Sites] Load All Sites List Action",
  props<{ response: any[] }>()
);
export const getSitesExcelList = createAction(
  "[Sites] Get All Sites Excel List Action",
  props<{ options: any }>()
);
export const loadSitesExcelList = createAction(
  "[Sites] Load All Sites Excel List Action",
  props<{ response: any[] }>()
);

// Table Configuration Settings
export const getSitesTableConfig = createAction(
  "[Sites] Get Sites Table Configuration Action",
  props<{ options: any }>()
);
export const loadSitesTableConfig = createAction(
  "[Sites] Load Sites Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveSitesTableConfig = createAction(
  "[Sites] Save Sites Table Configuration Action",
  props<{ config: any }>()
);

// Categories and Properties for the table
export const getCategoriesForListByUsage = createAction(
  "[Sites] Get All Categories for the Sites by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadCategoriesForListByUsage = createAction(
  "[Sites] Load All Categories for the Sites by Usage Action",
  props<{ response: any[] }>()
);
export const getPropertiesForListByUsage = createAction(
  "[Sites] Get All Properties for the Sites by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadPropertiesForListByUsage = createAction(
  "[Sites] Load All Properties for the Sites by Usage Action",
  props<{ response: any[] }>()
);
export const loadDeviceWarehousePropertiesForListByUsage = createAction(
  "[Sites] Load All Properties for the Site Device Warehouse by Usage Action",
  props<{ response: any[] }>()
);
export const loadDevicePosPropertiesForListByUsage = createAction(
  "[Sites] Load All Properties for the Site Device POS by Usage Action",
  props<{ response: any[] }>()
);

export const getSiteRegionsList = createAction(
  "[Sites] Get All Site Regions List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadSiteRegionsList = createAction(
  "[Sites] Load All Site Regions List Action",
  props<{ response: any[] }>()
);
export const getWarehouseTypesList = createAction(
  "[Sites] Get All Warehouse Types List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadWarehouseTypesList = createAction(
  "[Sites] Load All Warehouse Types List Action",
  props<{ response: any[] }>()
);
export const getPumpTypesList = createAction(
  "[Sites] Get All Pump Types List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadPumpTypesList = createAction(
  "[Sites] Load All Pump Types List Action",
  props<{ response: any[] }>()
);
export const getPriceSignTypesList = createAction(
  "[Sites] Get All Price Sign Types List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadPriceSignTypesList = createAction(
  "[Sites] Load All Price Sign Types List Action",
  props<{ response: any[] }>()
);
export const getPosTypesList = createAction(
  "[Sites] Get All Pos Types List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadPosTypesList = createAction(
  "[Sites] Load All Pos Types List Action",
  props<{ response: any[] }>()
);
export const getSiteProfileList = createAction(
  "[Sites] Get All Site Profile List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadSiteProfileList = createAction(
  "[Sites] Load All Site Profile List Action",
  props<{ response: any[] }>()
);
export const getEnabledSitesList = createAction(
  "[Sites] Get All Enabled Sites List Action",
  props<{ options: any }>()
);
export const loadEnabledSitesList = createAction(
  "[Sites] Load All Enabled Sites List Action",
  props<{ response: any[] }>()
);
export const getSiteWarehouseList = createAction(
  "[Sites] Get All Warehouses by Site List Action",
  props<{ code: string, pageReq?: PaginationRequest }>()
);
export const loadSiteWarehouseList = createAction(
  "[Sites] Load All Warehouses by Site List Action",
  props<{ response: any[] }>()
);
export const createWarehouse = createAction(
  "[Sites] Create Warehouse Action",
  props<{ warehouse: any }>()
);
export const updateWarehouse = createAction(
  "[Sites] Update Warehouse Action",
  props<{ warehouse: any }>()
);

export const getSite = createAction(
  "[Sites] Get Site Action",
  props<{ code: string }>()
);
export const loadSite = createAction(
  "[Sites] Load Site Action",
  props<{ response: any }>()
);
export const resetSite = createAction("[Sites] Reset Site Action");
export const resetCreation = createAction("[Sites] Reset Creation Action");
export const createSite = createAction(
  "[Sites] Create Site Action",
  props<{ site: any }>()
);
export const updateSite = createAction(
  "[Sites] Update Site Action",
  props<{ site: any }>()
);

export const getSiteDispenserList = createAction(
  "[Sites] Get All Dispensers by Site List Action",
  props<{ code: string, pageReq?: PaginationRequest }>()
);
export const loadSiteDispenserList = createAction(
  "[Sites] Load All Dispensers by Site List Action",
  props<{ response: any[] }>()
);
export const resetDispenser = createAction("[Sites] Reset Dispenser Action");
export const createDispenser = createAction(
  "[Sites] Create Dispenser Action",
  props<{ dispenser: any }>()
);
export const updateDispenser = createAction(
  "[Sites] Update Dispenser Action",
  props<{ dispenser: any }>()
);
export const getSiteFccList = createAction(
  "[Sites] Get All Fcc's by Site List Action",
  props<{ code: string, pageReq?: PaginationRequest }>()
);
export const loadSiteFccList = createAction(
  "[Sites] Load All Fcc's by Site List Action",
  props<{ response: any[] }>()
);
export const createFcc = createAction(
  "[Sites] Create FCC Action",
  props<{ fcc: any }>()
);
export const updateFcc = createAction(
  "[Sites] Update FCC Action",
  props<{ fcc: any }>()
);
export const getSitePosList = createAction(
  "[Sites] Get All Pos's by Site List Action",
  props<{ code: string, pageReq?: PaginationRequest }>()
);
export const loadSitePosList = createAction(
  "[Sites] Load All Pos's by Site List Action",
  props<{ response: any[] }>()
);
export const createPos = createAction(
  "[Sites] Create POS Action",
  props<{ pos: any }>()
);
export const updatePos = createAction(
  "[Sites] Update POS Action",
  props<{ pos: any }>()
);
export const getFccDeviceSubtypesList = createAction(
  "[Sites] Get All Fcc Device Sub Types List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadFccDeviceSubtypesList = createAction(
  "[Sites] Load All Fcc Device Sub Types List Action",
  props<{ response: any[] }>()
);
export const getSiteFuelPointList = createAction(
  "[Sites] Get All FuelPoints by Site List Action",
  props<{ code: string, pageReq?: PaginationRequest }>()
);
export const loadSiteFuelPointList = createAction(
  "[Sites] Load All FuelPoints by Site List Action",
  props<{ response: any[] }>()
);
export const createFuelPoint = createAction(
  "[Sites] Create FuelPoint Action",
  props<{ fuelpoint: any }>()
);
export const updateFuelPoint = createAction(
  "[Sites] Update FuelPoint Action",
  props<{ fuelpoint: any }>()
);
export const getSitePriceSignList = createAction(
  "[Sites] Get All Price Signs by Site List Action",
  props<{ code: string, pageReq?: PaginationRequest }>()
);
export const loadSitePriceSignList = createAction(
  "[Sites] Load All Price Signs by Site List Action",
  props<{ response: any[] }>()
);
export const createPriceSign = createAction(
  "[Sites] Create Price Sign Action",
  props<{ priceSign: any }>()
);
export const updatePriceSign = createAction(
  "[Sites] Update Price Sign Action",
  props<{ priceSign: any }>()
);
export const getSiteProductList = createAction(
  "[Sites] Get Site Product List Action",
  props<{ code: string }>()
);
export const loadSiteProductList = createAction(
  "[Sites] Load Site Product List Action",
  props<{ response: any[] }>()
);
export const createProductList = createAction(
  "[Sites] Create Product List Action",
  props<{ siteCode: string, productList: any[] }>()
);
export const getSiteFuelProductList = createAction(
  "[Sites] Get Site Fuel Product List Action",
  props<{ code: string }>()
  );
export const loadSiteFuelProductList = createAction(
  "[Sites] Load Site Fuel Product List Action",
  props<{ response: any[] }>()
);
export const createFuelProductList = createAction(
  "[Sites] Create Fuel Product List Action",
  props<{ siteCode: string, productList: any[] }>()
);
export const getSiteStoreProductList = createAction(
  "[Sites] Get Site Store Product List Action",
  props<{ code: string }>()
);
export const loadSiteStoreProductList = createAction(
  "[Sites] Load Site Store Product List Action",
  props<{ response: any[] }>()
);
export const createStoreProductList = createAction(
  "[Sites] Create Store Product List Action",
  props<{ siteCode: string, productList: any[], searchTerms: any }>()
);
export const getSiteGradeList = createAction(
  "[Sites] Get Site Grade List Action",
  props<{ code: string }>()
);
export const loadSiteGradeList = createAction(
  "[Sites] Load Site Grade List Action",
  props<{ response: any[] }>()
);
export const createGradeList = createAction(
  "[Sites] Create Grade List Action",
  props<{ siteCode: string, gradeList: any[] }>()
);
export const getSitePeripheralList = createAction(
  "[Sites] Get All Peripherals by Site List Action",
  props<{ code: string, pageReq?: PaginationRequest }>()
);
export const loadSitePeripheralList = createAction(
  "[Sites] Load Site Peripherals List Action",
  props<{ response: any[] }>()
);
export const getPeripheralDeviceSubtypesList = createAction(
  "[Sites] Get All Peripheral Device Sub Types List Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadPeripheralDeviceSubtypesList = createAction(
  "[Sites] Load All Peripheral Device Sub Types List Action",
  props<{ response: any[] }>()
);
export const createPeripheral = createAction(
  "[Sites] Create Peripheral Action",
  props<{ peripheral: any }>()
);
export const updatePeripheral = createAction(
  "[Sites] Update Peripheral Action",
  props<{ peripheral: any }>()
);
export const getSiteMultimediaList = createAction(
  "[Sites] Get All Multimedia Devices by Site List Action",
  props<{ code: string, pageReq?: PaginationRequest }>()
);
export const loadSiteMultimediaList = createAction(
  "[Sites] Load Site Multimedia Devices List Action",
  props<{ response: any[] }>()
);
export const createMultimedia = createAction(
  "[Sites] Create Multimedia Device Action",
  props<{ multimediaDevice: any }>()
);
export const updateMultimedia = createAction(
  "[Sites] Update Multimedia Device Action",
  props<{ multimediaDevice: any }>()
);
export const setLoadingEndState = createAction("[Sites] Load End Action");
